<div class="tw-bg-[#FFE07F1A] tw-py-[5%]">
  <div class="container">
    <div class="tw-text-center">
      <p class="tw-text-xl md:tw-text-2xl lg:tw-text-3xl tw-font-extrabold tw-capitalize ">Save money with <br> PumPumPum Subscription</p>
      <!-- <p class="tw-text-xl md:tw-text-2xl lg:tw-text-3xl tw-font-extrabold"></p> -->
      <p class="tw-py-6 tw-text-[#4B4B4B]">Subscribing to a car is not just flexible and convenient, it might also save
        your money as compared to buying a
        car on loan.</p>
    </div>

    <div class="tw-flex md:tw-gap-x-4">
      <div class="tw-px-4 tw-flex-grow tw-w-1/2 tw-bg-white tw-border-[.5px] tw-border-[#DDDDDD] tw-rounded-t-md">
      </div>
      <div
        class="tw-flex tw-items-center tw-justify-center tw-py-2 md:tw-py-3 tw-text-xs md:tw-text-base tw-w-1/4 tw-flex-none tw-font-bold tw-text-center md:tw-w-32 lg:tw-w-64 tw-bg-[#FCEEC3] tw-border tw-border-[#F7B703] tw-rounded-t-md">
        PumPumPum Subscription
      </div>
      <div
        class="tw-flex tw-items-center tw-justify-center tw-bg-[#F7F7F7] tw-py-2 tw-text-xs md:tw-text-base tw-w-1/4 tw-flex-none tw-font-bold tw-text-center md:tw-w-32 lg:tw-w-64 tw-border-[.5px] tw-border-[#DDDDDD] tw-rounded-t-md">
        Buy
      </div>
    </div>
    <div class="tw-flex md:tw-gap-x-4" *ngFor="let item of subscriptionTable; let last = last;">
      <div [ngClass]="{'tw-rounded-b-md': last}"
        class="tw-text-sm md:tw-text-base tw-px-2 tw-py-2 tw-flex-grow md:tw-px-4 lg:tw-px-6 tw-w-1/2 tw-bg-white tw-border-b-[.5px] tw-border-b-[#DDDDDD] tw-border-r-[.5px] tw-border-r-[#DDDDDD] tw-border-l-[.5px] tw-border-l-[#DDDDDD]">
        {{item}}
      </div>

      <div [ngClass]="{'tw-rounded-b-md': last, 'tw-border-b-2': last, 'tw-border-b-[.5px]': !last}"
        class="tw-flex tw-items-center tw-justify-center tw-flex-none tw-w-1/4 tw-text-center md:tw-w-32 lg:tw-w-64 tw-bg-[#FFE07F1A] tw-border-b-[#F7B70380] tw-border-r tw-border-r-[#F7B703] tw-border-l tw-border-l-[#F7B703]">
        <fa-icon class="tw-text-[#3DA543]" [icon]="faCheck"></fa-icon>
      </div>

      <div [ngClass]="{'tw-rounded-b-md tw-border-b': last}"
        class="tw-flex tw-items-center tw-justify-center tw-flex-none tw-w-1/4 tw-text-center md:tw-w-32 lg:tw-w-64 tw-bg-white tw-border-b-[.5px] tw-border-b-[#DDDDDD] tw-border-r-[.5px] tw-border-r-[#DDDDDD] tw-border-l-[.5px] tw-border-l-[#DDDDDD]">
        <fa-icon class="tw-text-[#E42C2C]" [icon]="faTimes"></fa-icon>
      </div>
    </div>

    <div class="md:tw-hidden tw-text-right">
      <button (click)="showAll=!showAll;isSmallScreen();"
        class="tw-font-bold tw-py-4 tw-cursor-pointer">
        Show {{showAll? 'less' : 'more'}} ...
      </button>
    </div>

    <div class="tw-text-center tw-mt-[5%]">
      <a [routerLink]="'cars'" aria-label="Browse all Cars" (click)="browseCarClick($event)"
        class="hover:tw-text-white tw-rounded-md tw-bg-pinkDark tw-px-4 tw-py-2 tw-text-white">
        Browse Cars &nbsp;<fa-icon [icon]="faArrowRight"></fa-icon>
      </a>
    </div>
  </div>
</div>